function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["bgColor", "children", "className", "cornerRadius", "dataTestId", "elevation", "marginBottom", "marginLeft", "marginRight", "marginTop", "padding", "paddingBottom", "paddingLeft", "paddingRight", "paddingTop"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React, { forwardRef } from 'react';
import { useTheme } from 'styled-components';
import StyledBox from "./styled";
import BackgroundProvider from "../BackgroundProvider";
import { useBrand } from "../BrandProvider";
import { getResponsiveValue } from "../../utils";
/**
 * Documentation:
 *
 * - [Link for Windows (On-prem)](https://pages.ghe.service.group/constellation/docs/components/box)
 **/
var Box = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _theme$vars;
  var _ref$bgColor = _ref.bgColor,
    bgColorProp = _ref$bgColor === void 0 ? 'neutral1' : _ref$bgColor,
    children = _ref.children,
    customClass = _ref.className,
    _ref$cornerRadius = _ref.cornerRadius,
    cornerRadius = _ref$cornerRadius === void 0 ? 'default' : _ref$cornerRadius,
    dataTestId = _ref.dataTestId,
    _ref$elevation = _ref.elevation,
    elevationProp = _ref$elevation === void 0 ? 'default' : _ref$elevation,
    _ref$marginBottom = _ref.marginBottom,
    marginBottom = _ref$marginBottom === void 0 ? '05' : _ref$marginBottom,
    _ref$marginLeft = _ref.marginLeft,
    marginLeft = _ref$marginLeft === void 0 ? 'none' : _ref$marginLeft,
    _ref$marginRight = _ref.marginRight,
    marginRight = _ref$marginRight === void 0 ? 'none' : _ref$marginRight,
    _ref$marginTop = _ref.marginTop,
    marginTop = _ref$marginTop === void 0 ? 'none' : _ref$marginTop,
    _ref$padding = _ref.padding,
    padding = _ref$padding === void 0 ? 'default' : _ref$padding,
    paddingBottom = _ref.paddingBottom,
    paddingLeft = _ref.paddingLeft,
    paddingRight = _ref.paddingRight,
    paddingTop = _ref.paddingTop,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _ref2 = useBrand() || {},
    brand = _ref2.brand,
    _ref2$testAttributeNa = _ref2.testAttributeName,
    testAttributeName = _ref2$testAttributeNa === void 0 ? 'data-qa-id' : _ref2$testAttributeNa;
  var theme = useTheme();
  var className = classnames('csl-box', customClass);
  var testAttributes;
  var getTestAttributes = function getTestAttributes(element) {
    var _testAttributes;
    return ((_testAttributes = testAttributes) === null || _testAttributes === void 0 ? void 0 : _testAttributes[element]) || {};
  };
  if (dataTestId) {
    testAttributes = {};
    testAttributes.default = _defineProperty({}, testAttributeName, dataTestId);
  }
  var bgColor = bgColorProp;

  /* @ts-ignore */
  if (bgColor === 'default1') {
    bgColor = 'neutral1';
    console.warn('Box bgColor `default1` is deprecated. Please use `neutral1` instead.');
  }

  /* @ts-ignore */
  if (bgColor === 'default2') {
    bgColor = 'neutral2';
    console.warn('Box bgColor `default2` is deprecated. Please use `neutral2` instead.');
  }
  if (!theme["box_color_background_".concat(bgColor)]) {
    bgColor = 'neutral1';
    console.warn("Background colour \"".concat(bgColor, "\" in Box component for brand \"").concat(brand, "\" is not available. Use an alternative colour."));
  }
  var elevation = elevationProp;

  // @ts-ignore
  if (elevation === 0) {
    elevation = 'none';
    console.warn('Box elevation `0` is deprecated. Please use `"none"` instead.');
  }

  // @ts-ignore
  if (elevation === 1) {
    elevation = '01';
    console.warn('Box elevation `1` is deprecated. Please use `"01"` instead.');
  }

  // @ts-ignore
  if (elevation === 2) {
    elevation = '02';
    console.warn('Box elevation `2` is deprecated. Please use `"02"` instead.');
  }
  if (!['default', 'none'].includes(elevation)) {
    if (!theme["box_background_".concat(bgColor, "_elevation_").concat(elevation, "_shadow_css")]) {
      console.warn("Elevation value \"".concat(elevation, "\" in Box component is not available with \"").concat(bgColor, "\" background colour."));
    }
  }
  return /*#__PURE__*/React.createElement(StyledBox, _extends({
    $bgColor: bgColor,
    $cornerRadius: cornerRadius,
    $elevation: elevation,
    $marginBottom: getResponsiveValue(marginBottom),
    $marginLeft: getResponsiveValue(marginLeft),
    $marginRight: getResponsiveValue(marginRight),
    $marginTop: getResponsiveValue(marginTop),
    $padding: getResponsiveValue(padding),
    $paddingBottom: getResponsiveValue(paddingBottom),
    $paddingLeft: getResponsiveValue(paddingLeft),
    $paddingRight: getResponsiveValue(paddingRight),
    $paddingTop: getResponsiveValue(paddingTop)
  }, getTestAttributes('default'), {
    className: className,
    ref: ref
  }, rest), bgColor !== 'none' ? /*#__PURE__*/React.createElement(BackgroundProvider, {
    value: {
      colorName: bgColor,
      cssValue: (_theme$vars = theme.vars) === null || _theme$vars === void 0 ? void 0 : _theme$vars["box_color_background_".concat(bgColor)]
    }
  }, children) : children);
});
Box.displayName = 'Box';
export default Box;